var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14L4.5 9M4.5 9L9.5 4M4.5 9H15C15.7223 9 16.4375 9.14226 17.1048 9.41866C17.772 9.69506 18.3784 10.1002 18.8891 10.6109C19.3998 11.1216 19.8049 11.728 20.0813 12.3952C20.3577 13.0625 20.5 13.7777 20.5 14.5C20.5 15.2223 20.3577 15.9375 20.0813 16.6048C19.8049 17.272 19.3998 17.8784 18.8891 18.3891C18.3784 18.8998 17.772 19.3049 17.1048 19.5813C16.4375 19.8577 15.7223 20 15 20H11.5",
    stroke: "#34656D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.93734e82113df6fa81ce5748b365eecc.svg";
export { ForwardRef as ReactComponent };